export default Object.freeze({
  Crianca_Sozinha: new Map([
    ['Não', 0],
    ['Não se aplica', 0],
    ['Sim', 0],
    ['Não observado', 0],
  ]),
  Crianca_acomp_Adulto: new Map([
    ['Não', 0],
    ['Não se aplica', 0],
    ['Sim', 0],
    ['Não observado', 0],
  ]),
  Parentes_no_CA: new Map([
    ['Não', 0],
    ['Sim', 0],
    ['Não informado', 0],
  ]),
  Presenca_Moradia_Improvisada: new Map([
    ['Não', 0],
    ['Não se aplica', 0],
    ['Sim', 0],
    ['Não observado', 0],
  ]),
  Classificacao_de_idade: new Map([
    ['Sem informação', 0],
    ['Adulto', 0],
    ['Juventude', 0],
    ['Adolescente', 0],
    ['Idoso', 0],
    ['Criança', 0],
  ]),
  Cor_Raca_Etnia: new Map([
    ['Parda', 0],
    ['Branca', 0],
    ['Preta', 0],
    ['Indígena', 0],
    ['Amarela', 0],
    ['Sem identificação', 0],
    ['Não respondeu', 0],
  ]),
  Faixa_de_idade: new Map([
    ['Até 11', 0],
    ['31 a 49', 0],
    ['18 a 30', 0],
    ['12 a 17', 0],
    ['50 a 59', 0],
    ['60 a 69', 0],
    ['70 a 79', 0],
    ['80 a 89', 0],
    ['90 a 99', 0],
    ['Sem informação', 0],
  ]),
  Identifica_com_o_sexo_nasceu: new Map([
    ['Não respondeu', 0],
    ['Homem Cisgênero', 0],
    ['Mulher Cisgênero', 0],
    ['Agênero', 0],
    ['Outra', 0],
    ['Mulher Transexual', 0],
    ['Travesti', 0],
    ['Homem Transexual', 0],
    ['Não Binário', 0],
  ]),
  Sexo: new Map([['Masculino', 0], ['Feminino', 0], ['Sem identificação', 0]]),
  Situacao_de_rua: new Map([['Acolhido', 0], ['Rua', 0]]),
  Tempo_na_situacao: new Map([
    ['NR/NS', 0],
    ['Até 1 semana', 0],
    ['Entre 1 semana e 1 mês', 0],
    ['Mais de 1 mês até 6 meses', 0],
    ['Mais de 6 meses até 1 ano', 0],
    ['Mais de 1 ano até 2 anos', 0],
    ['Mais de 2 anos até 5 anos', 0],
    ['Mais de 5 anos até 10 anos', 0],
    ['Mais de 10 anos', 0],
  ]),
  Tipo_de_ponto: new Map([
    ['Praça', 0],
    ['Não se aplica', 0],
    ['Calçada', 0],
    ['Canteiro central', 0],
    ['Baixos de Viaduto', 0],
    ['Estação de trem/metrô', 0],
    ['Marquise', 0],
    ['Outro', 0],
    ['Terreno baldio', 0],
    ['Mocó', 0],
    ['Terminal de ônibus', 0],
    ['Cemitério', 0],
    ['Veículo', 0],
    ['Área externa de imóvel (recuo de garagem)', 0],
    ['Parque', 0],
  ]),
  Tempo_de_permanência: new Map([
    ['Não se aplica', 0],
    ['Não respondeu/Não sabe', 0],
    ['Até 1 semana', 0],
    ['Entre 1 e 2 semanas', 0],
    ['Entre 2 semanas e 1 mês', 0],
    ['Entre 1 mês e 3 meses', 0],
    ['Entre 3 meses e 6 meses', 0],
    ['Mais de 6 meses', 0],
  ]),
  Onde_dormiu_ontem: new Map([
    ['Não se aplica', 0],
    ['Não respondeu/Não sabe', 0],
    ['Neste centro de acolhida (aqui)', 0],
    ['Rua', 0],
    ['Casa própria', 0],
    ['Casa de amigos/parentes', 0],
    ['Outro centro de acolhida', 0],
    ['Outro', 0],
  ]),
  Idade: new Map(),
})
